import { createSlice } from '@reduxjs/toolkit';
import { User } from 'api/auth/_requests';

const initialState = {
  user: null as User | null
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    updateAvatar: (state, action) => {
      if (state.user) {
        state.user.avatar = action.payload;
      }
    }
  }
});

export const { setUser, updateUser, updateAvatar } = authSlice.actions;
export default authSlice.reducer;
